export default __webpack_public_path__ + "static/media/ojeras.dfff0e75.jpg";